import Cookies from 'js-cookie'

const AuthenticationInterceptor = () => {
  // Note: This function should be executed on page load.
  // This function will:
  // check cookie for login event
  // and if cookie is present
  // it will remove it
  // and push tracking event to GA

  const availableAuthCookies = {
    login: '_cgtrader_slsd89',
    register: '_cgtrader_sssd90',
  }

  const availableAuthTypes = {
    email: 'email',
    google: 'Google',
    facebook: 'Facebook',
  }

  const cleanup = (name) => {
    Cookies.remove(name)
  }

  const getCookie = (name) => {
    if (name) {
      return Cookies.get(name)
    }

    return null
  }

  const trackEvent = ({ method, type }) => {
    const isTypeAcceptable = availableAuthTypes[type]

    // take user id from APP.config.userId - for slow application
    // or from window.pageConfig.currentUserId - for fast application
    const userId = window.App?.config?.userId
      || window.pageConfig?.currentUserId
      || ''

    if (window.dataLayer
      && isTypeAcceptable
    ) {
      window.dataLayer.push({
        event: 'GTMevent',
        event_name: method,
        user_id: userId,
        event_data: {
          method: isTypeAcceptable,
        },
        _clear: true,
      })
    }
  }

  const checkUserInfo = (callback, delay, repeat) => {
    let count = 0
    const interval = setInterval(() => {
      const shouldInterrupt = callback()

      if (++count === repeat || shouldInterrupt) {
        window.clearInterval(interval)
      }
    }, delay)
  }

  const isDefined = window.cookieInterceptor

  if (!isDefined) {
    window.cookieInterceptor = true
  }

  if (Cookies && !isDefined) {
    const authMethods = Object.keys(availableAuthCookies)

    const currentCookie = authMethods.reduce((acc, method) => {
      const cookie = getCookie(availableAuthCookies[method])

      if (cookie) {
        return { method, type: cookie }
      }

      return acc
    }, null)

    if (currentCookie) {
      // delay for 5 seconds to make sure user info is loaded
      checkUserInfo(() => {
        if (window.App?.config?.userId || window.pageConfig?.currentUserId) {
          trackEvent(currentCookie)
          cleanup(availableAuthCookies[currentCookie.method])
          return true
        }

        return false
      }, 1000, 5)
    }
  }
}

export { AuthenticationInterceptor }
